import AccessApprovalDetail from "./accessApprovalDetail";
import {connect} from "react-redux";
import { getUser } from "../../../../redux/actions/userManagement/userViewer.action";
import { getPredefinedRoles } from "../../../../redux/actions/userManagement/functionalRoles.action";
import { updateUserPermissions } from "../../../../redux/actions/userManagement/updatePermissions.action";
import { getCustomerDetails } from "../../../../redux/actions/userManagement/customer.action";
import { openAlertPopup, closeAlertPopup } from "../../../../redux/actions/Alert/alert.action";
import { AddOnboardingComment } from "../../../../redux/actions/userManagement/onboardingAddComment.action";
import { getAllCustomerList } from "../../../../redux/actions/userManagement/getAllCustomerList.action";
import { AddExtensionAccessRequest } from "../../../../redux/actions/userManagement/extensionAccessRequest.action";


const mapStateToProps = (state) => {
    return {
        userList:state.userViewer.data,
        customer:state.onboardingRequest.getAllCustomerList.data,
        isLoadingCustomer:state.CustomerDetail.loading,
        isLoading:state.userViewer.isLoading,
        next:state.userViewer.next,
        functionalRoles:state.functionalRoles.roles,
        myRights:state.myRights.myRights,
        list:state.onboardingRequest.getAllCustomerList.data,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getUser: (type,custID,searchKey,next=null) => {
            return dispatch(getUser(type,custID,searchKey,next))
        },
        getDetails: (customerID) => {
            return dispatch(getCustomerDetails(customerID))
        },

        getPredefinedRoles: (filter) => {
            return dispatch(getPredefinedRoles(filter))
        },
        updateUserPermissions: (payload,id) => {
            return dispatch(updateUserPermissions(payload,id))
        },
        openAlertPopup: (payload) => {
            return dispatch(openAlertPopup(payload))
        },
        closeAlertPopup: () => {
            return dispatch(closeAlertPopup())
        },
        // accessRequest: (payload) => {
        //     return dispatch(AddOnboardingComment(payload))
        // },
        AddExtensionAccessRequest: (payload) => {
            return dispatch(AddExtensionAccessRequest(payload))
        },
        getAllCustomerList:() => {
            return dispatch(getAllCustomerList());
          }
        
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AccessApprovalDetail);

